import { FixElementRuleIds, RuleId, ValidatedArray } from '../../values/index.js';
export const Props = (props = {}) => ({
    typographyIds: ValidatedArray(RuleId, props.typographyIds),
    paletteIds: ValidatedArray(RuleId, props.paletteIds)
});
export const fix = (props, styles) => ({
    paletteIds: FixElementRuleIds('palette', props.paletteIds, styles),
    typographyIds: FixElementRuleIds('typography', props.typographyIds, styles)
});
export const validate = () => true;
export const type = 'text';
export const label = 'Text elements';
export const category = 'element';
export const aspects = ['typography', 'palette'];
//# sourceMappingURL=text.js.map